var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDusk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_63423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3580_63423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3580_63423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.71 67.1372C1844.95 123.118 1892.5 190.132 1926 264.807V-130.532C1892.52 -55.8372 1844.95 11.1559 1786.71 67.1372Z",
    fill: "url(#paint0_linear_3580_63423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.137C838.253 -1.17986 783.121 -85.9241 750.018 -180.998H362.291C416.72 -87.5487 447.937 21.1044 447.937 137.059C447.937 422.22 259.31 663.295 0.00195312 742.483V903.146H841.423C761.996 797.381 714.929 665.943 714.929 523.492C714.929 344.195 789.521 182.329 909.335 67.1571V67.137Z",
    fill: "url(#paint1_linear_3580_63423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.096 67.1351C1022.89 -42.2401 1177.47 -109.474 1347.78 -109.474C1518.09 -109.474 1672.67 -42.2201 1786.47 67.1351C1844.71 11.1537 1892.26 -55.8594 1925.76 -130.535V-181H749.78C782.883 -85.926 838.035 -1.16174 909.096 67.1351Z",
    fill: "url(#paint2_linear_3580_63423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.937 137.059C447.937 21.1044 416.72 -87.5287 362.291 -180.998H0.00195312V742.463C259.31 663.295 447.937 422.2 447.937 137.038V137.059Z",
    fill: "url(#paint3_linear_3580_63423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.1365C1023.13 176.512 1177.71 243.745 1348.02 243.745C1518.33 243.745 1672.91 176.492 1786.71 67.1365C1672.91 -42.2387 1518.33 -109.472 1348.02 -109.472C1177.71 -109.472 1023.13 -42.2187 909.335 67.1365Z",
    fill: "url(#paint4_linear_3580_63423)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_63423",
    x1: 1926,
    y1: 709.927,
    x2: 1926,
    y2: -611.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_63423",
    x1: 1346.4,
    y1: 903.128,
    x2: -1180.23,
    y2: -227.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_63423",
    x1: 609.395,
    y1: 125.317,
    x2: 3004.13,
    y2: 125.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_63423",
    x1: -451.47,
    y1: 237.435,
    x2: 1038.08,
    y2: 237.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_63423",
    x1: 1074.12,
    y1: 425.631,
    x2: 1682.75,
    y2: -679.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#4FCCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#883AC3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_63423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDusk);
export default __webpack_public_path__ + "static/media/dusk.12d0af31192e9bb69f8aff0fc66d05bf.svg";
export { ForwardRef as ReactComponent };